export default __webpack_public_path__ + "images/1e42ab78fcb317fb5b53ee36daf6d582.svg";